import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        textAlign: 'center',
      }}
    >
      <Seo title={t('notFound.title')} description={t('notFound.description')} />
      <div
        style={{
          width: '100%',
          maxWidth: 360,
          height: 200,
          marginBottom: 24,
          backgroundImage: 'url(/images/offline.jpg)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'center',
        }}
        role="img"
        aria-label={t('notFound.title')}
      />

      <h1 style={{ marginBottom: '16px' }}>{t('notFound.title')}</h1>
      <p style={{ marginBottom: '24px', color: '#666' }}>
        {t('notFound.description')}<br />
        {t('notFound.hint')}
      </p>
      <Link
        to="/"
        style={{
          display: 'inline-block',
          padding: '8px 16px',
          borderRadius: 4,
          backgroundColor: '#1677ff',
          color: '#fff',
          textDecoration: 'none',
        }}
      >
        {t('notFound.backHome')}
      </Link>
    </main>
  );
};

export default NotFound;
